export default {
    'Number': 'NO.',
    'NoData': 'No result',
    'Cancel': 'Cancel',
    'OK': 'OK',
    'Import': 'Import',
    'StartImport': 'Start to import',
    'importWorkflowTips': 'Process view cannot be imported',
    'ImportData': 'Import data',
    'ReImport': 'Import again',
    'ReUpload': 'Upload again',
    'Skip': 'Skip',
    'SureImport': 'Import',
    'ExportFailure': 'Export failed',
    'ExportLoading': 'Please wait while the build excel is in progress ...',
    'AllBeShown': 'Completed to load',
    'DeleteItems': 'Are you sure to delete the data？',
    'BizData': 'Non-workflow Data',
    'wlData1': 'Workflow data without influenced workflow',
    'wlData2': 'Parent process which related with child process',
    'wlData3': 'Child process Data',
    'DeleteItems1': '(It will delete related workflow Data after the data deleted.)',
    'DeleteItems2': '(The child process data will be deleted while its parent process data been deleted.)',
    'DeleteItems3': '(The instance data and its relationship with parent process will be deleted while the child process data been deleted.)',
    'NotAllowedDelete': 'Normal user cannot delete the workflow data',
    'NotDraftDelete': 'NotAllowedDelete',
    'BusinessRuleException': '[{propertyCode}] not exist which user in node name [{nodeName}] in business rules name [{businessRuleName}] on [{schemaName}] model,you can contact the administrator',
    'LogicCheckException': 'No validation data was found from target model name 【{targetSchemaName}】 in 【{nodeName}】',
    'Items': 'items',
    'NoPermissionAdd': 'You have not the permission to initiate the process',
    'NoPublish': 'Process has not been released',
    'NoPermissionDelete': 'You don`t have permission',
    'DeleteItemsTips': '{successCount} items have been deleted，{errorCount} items faild with permission limited',
    'DeleteFailed': 'Delete failed',
    'DeleteLoading': 'Delete to load',
    'DeleteSuccess': 'Delete successfully',
    'GenerationFailed': 'File generation failed, please select again',
    'FileIsBeingExported': 'The file is being exported',
    'Query': 'Search',
    'Add': 'Add',
    'Reset': 'Reset',
    'More': 'More',
    'TakeUp': 'Fold',
    'Delete': 'Delete',
    'DeleteTips1': 'The following data cannot be recovered after deletion',
    'NoSearchResult': 'No resulet',
    'ContentLoadingFailed': 'Faild to load',
    'Refresh': 'Refresh',
    'Loading': 'Loading',
    'ImportTips1': 'For make sure the data is legal,please ',
    'ImportTips2': 'Download the sample file',
    'ImportTips3': 'Only support .xlsx file',
    'ImportTips4': 'Please do not close the windows otherwise it will be interrupted',
    'ImportTips5': 'System error,faild to import,please import again!',
    'ImportTips6': '{num} items have been imported successfully',
    'ImportTips7': '{num} items have been imported failed',
    'ImportTips8': 'Please import agin after revise',
    'ImportTips9': 'Limited to 500 lines to import,please revise and import again',
    'ImportTips10': 'The list title of the file is not compat with the list,please check',
    'ImportTips11': 'Only one file can be uploaded',
    'ImportWarn': 'Data import does not support import process data, please check carefully before importing!',
    'ImportLocalFaile': 'Upload the local file',
    'ClickToImport': 'Click or drag file to upload',
    'DownloadFailed': 'Download failed',
    'Importing': 'Importing',
    'ImportSuccess': 'Import successed',
    'ImportTestError': 'Parameter validation failed on reimport!',
    'ImportFailed': 'Import failed',
    'DownloadFailedList': 'Download the list',
    'SampleFile': 'Sample file',
    'Recheck': 'Check again',
    'ChooseQueryFiled': 'Select the query field',
    'ChooseQueryFiledTips': 'When importing, it queries the existing data according to the query field, overrides the import if it exists, and adds the import if it does not exist,supports only name, sequenceStatus, short text class data items.',
    'Total': 'Total {num} item(s)',
    'Screen': 'Filter',
    'SetDisplayItems': 'Display items',
    'FormTrack': 'Form track',
    'Comment': 'Comment',
    'CopyLink': 'Copy link',
    'CopySuccess': 'Copy successed',
    'CopyFailed': 'Copy failed',
    'OpenInNewPage': 'Open in new page',
    'recovery': 'Restore default settings',
    'chooseColumns': 'Please setup the display items',
    'dragToSort': 'Sort by tap and hold-drag',
    'checkAll': 'Select All',
    'mainTableField': 'Main Table Field',
    'printQrcode': 'Print qrcode',
    'qrcode': 'Qrcode',
    'dingtalk': 'Dingtalk',
    'enterpriseWechet': 'Enterprise wechat',
    'scanCodeView': 'Scan code to view data by {equip}',
    'scanCodeFill': 'Scan code to fill in data by {equip}',
    'totalTip': 'Current total {total} items; please scan the qrcode to check whether the printed data is correct during preview',
    'chooseTagSize': 'Selection of Label Paper Size',
    'width': 'width',
    'height': 'height',
    'qrcodeText': 'Base Text of qrcode',
    'qrcodeSet': 'QR code settings',
    'bizDataItem': 'bizModel dataitem',
    'sysDataItem': 'system dataitem',
    'textNumber': 'Bottom Text Number',
    'mostShowOne': 'Show up to one line of content',
    'example': 'Example',
    'qrcodeTextExample': 'QR code copy example',
    'preview': 'preview',
    'changeBefore': 'Before: ',
    'changeAfter': 'After: ',
    'download': 'Down.',
    'print': 'Print preview',
    'pleaseSelect': 'Please select',
    'recentSearch': 'Recent search',
    'noMatchResults': 'No matching results',
    'startExport': 'Start export',
    'export': 'Export',
    'exportData': 'Export data',
    'checkAll1': 'Select all fields',
    'exportTips': 'The system will export checked field data',
    'loading': 'Building',
    'importTitleTips': 'Please confirm the duplicate / empty data value of 【userName】',
    'chooseUser': 'Choose user',
    'chooseData': 'You have not select any data.',
    'chooseSheetData': 'You have not select any sheet data.',
    'null': 'null',
    'notData': 'null',
    'dataRepeat': 'repeat',
    'dataNoExisted': 'noExisted',
    'dataDeptDisable': 'Department disabled',
    'onlyDataDept': 'Single selection only',
    'repeat': '(repeat)',
    'noExisted': '(noExisted)',
    'deptDisable': '(Department disabled)',
    'onlyData': '（Single selection only）',
    'loadMore': 'loadMore',
    'loadCompleted': 'All data loaded',
    'modifyOwner': 'Modify owner',
    'selectOwner': 'Select owner',
    'owner': 'Owner',
    'ownerDepartment': 'Owner department',
    'modifyExplain': 'modify explain',
    'placeholder': 'Please input',
    'pleaseSelectOwner': 'Please select owner',
    'selectedField': 'Selected fields',
    'numbers': '{num}',
    'exportRecord': 'Export record',
    'unfinished': 'Unfinished',
    'finished': 'Finished',
    'exporting': 'Exporting',
    'reExport': 'Export again',
    'placeInputSearch': 'Please input',
    'placeInputModel': 'Please input',
    'placeInputKey': 'Please input',
    'noDataTree': 'Your associated model has not created data yet, so you cannot set query conditions.',
    'noDataTree2': "You haven't created data yet, so you can't set the hierarchical relationship",
    'noDataTree3': 'No matching data',
    'treeDataLoading': 'Data request, please wait...',
    'Equal': 'Equal',
    'NoEqual': 'Not Equal',
    'ISNULL': 'IS NULL',
    'ISNOTNULL': 'IS Not NULL',
    'noData': 'No data',
    'fileName': 'File Name',
    'fileSize': 'File Size',
    'modelName': 'Model Name',
    'exportTime': 'Export Time',
    'operation': 'Operation',
    'ownerTip': 'There are {num} datas which you do not have permission to modify, their owners  in the datas you selected. The system will not modify the owner of these {num} datas.',
    'modifySuccess': 'Modify success',
    'printformTips': 'Your bid data has exceeded {size}, please delete some data or reprint in batches',
    'isCustomizePrintTemp': 'The current data does not have a custom print template set or the print template function is not enabled',
    'selectDataTips': 'There are {num} error drop-down boxes',
    'radioDataTips': 'There are {num} error radio buttons',
    'checkboxDataTips': 'There are {num} error checkboxes',
    'importDataTips': 'The fields of cannot match, please enter the same options',
    'gotIt': "Got it",
    'complete': "Complete",
    'batchUpdata': 'Batch Update',
    'batchUpdataRecord': 'Batch Edit Record',
    'batchUpdataTips1': 'Business data items: pictures, attachments, maps, addresses, handwritten signatures, associated forms, and associated query fields do not support batch modification.',
    'batchUpdataTips2': 'System data items: document number, creator, creator department, creation time, modification time, and modifier do not support batch modification.',
    'batchUpdataTips3': 'The process form cannot be modified, only the business form can be modified.',
    'modifyField': 'Modify field',
    'modifyValue': 'Modify value',
    'modifyData': 'Modify data',
    'modifyFailed': 'Modify failed',
    'replaceWith': 'Replace with',
    'addResult': 'Add result',
    'filterCondition': 'Filter condition',
    'importTitleBatchTips': 'Only support batch correction of personnel, departments',
    'all': "All",
    'cacheFormData': 'Keep this submission when continuing to create',
    'Submit&Creating': 'Submit and continue creating',
    'invalidForm': 'This form has not been published. Please contact the administrator for processing',
    'sysDefaultTemplate': 'System default template',
    'printTemplate': 'Print template',
    'FormTrackTable': {
        'DataTitle': 'Name',
        'DataItem': 'Item',
        'Before': 'Before',
        'After': 'After',
        'LoadedAll': 'All data loaded',
    },
    'ListImportTips1': 'Select or drag and drop an Excel file to upload',
    'ListImportTips2': 'Support .xlsx format, up to 500 pieces of data at a time',
    'ListImportTips3': 'To ensure that the uploaded data matches the list content, please download ',
    'ListImportTips4': 'Import process data is not supported, please check carefully',
    'ListImportTips5': 'Data title and document number only support overwriting import',
    'ListImportTips6': 'Import data does not trigger business rules by default. To trigger, please check the developer manual',
    'ListImportTips7': 'Allow overwriting data when ',
    'ListImportTips8': ' Same, overwrite existing data',
    'ListImportTips9': 'Data importing, please do not close the page',
    'ListImportTips10': 'Data import failed',
    'ListImportTips11': 'Data import complete',
    'ListImportTips12': 'Data validation error',
    'ListImportTips13': 'Import failed, please re-import',
    'ListImportTips14': 'Successfully imported ',
    'ListImportTips15': ' pieces of data',
    'ListImportTips16': ' pieces of data, and ',
    'ListImportTips17': ' pieces of data failed to import',
    'ListImportTips18': 'Please ',
    'ListImportTips19': 'download error data',
    'ListImportTips20': ', modify and then import',
    'ListImportTips21': 'The form content in the current file is empty, please recheck and import the data',
    'ListImportTips22': 'Please refer to ',
    'ListImportTips23': ' to recheck',
    'barcode': 'Barcode',
    'workflowLog': 'Workflow Log',
    'workflowStamp': 'Workflow Stamp',
    'approval': 'Approval',
    'systemAuto': 'System automatically added',
    'receiveTime': 'Receive Time',
    'finishTime': 'Finish Time',
    'usedTime': 'Time consuming',
    'content': 'Handle comments',
};
